export default {
  productSuperseries: 'f39229d6-b84d-4e41-bb53-e1f705e7585c',
  homeTestSiteTemplateId: '0e34416d-6021-4c1a-bd17-a667cd3b0e6e',
  homeTemplateId: '78bd8dbe-3df5-4358-b464-6a8671f9dd96',
  interactiveImage: {
    dskHotspotId: '{092A8ED5-615E-4099-A1E4-36E54C1FA233}',
    mblHotspotId: '{987BCC8F-E6D3-464D-8709-52AFBB97F75B}',
  },
};
